import { withStyles, Grid } from "@material-ui/core";
import Dropdown from "../../../../../common/Dropdown";
import DriverImage from "../../Drivers/DriverInfoPopup/components/DriverImage";

const styles = (theme) => ({
  header: {
    top: 0,
    display: "flex",
    alignItems: "center",
    padding: 8,
  },
  contentPadding: {
    padding: "12px 20px 12px 4px",
    marginLeft: 4,
  },
  title: {
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderSelectedText,
  },
  labelValue: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
  },
  labelWithDropdown: {
    padding: 4,
    display: "block",
    paddingBottom: 0,
  },
  driverImg: {
    fontSize: 46,
    color: theme.iconColor,
    marginLeft: 8,
    opacity: 0.5,
  },
  imgStyle: {
    maxWidth: "46px",
    maxHeight: "46px",
  },
  driverStatusError: {
    color: theme.errorBorderColor,
    fontSize: 12,
  },
  errorPadding: {
    padding: "2px 4px",
  },
});

const PanelHeader = ({
  classes,
  data,
  isPreselectedDriver,
  handleDriverSelection,
  availableDriverOptions,
  dispatchInProgress,
  driverImage,
}) => {
  return (
    <div className={classes.header}>
      <DriverImage
        driverImage={driverImage}
        customStyle={{
          driverImg: classes.driverImg,
          imgStyle: classes.imgStyle
        }}
      />
      <Grid container className={classes.contentPadding}>
        {isPreselectedDriver || dispatchInProgress ? (
          <Grid item xs={12}>
            <div className={classes.title}>{data?.driverName}</div>
            <span
              className={classes.labelValue}
            >{`#${data?.driverNumber}`}</span>
            <div className={classes.driverStatusError}>
              {data?.driverError ?? ""}
            </div>
          </Grid>
        ) : (
          <Grid item xs={9}>
            <Dropdown
              placeholder="Select driver"
              autoFocus
              value={data?.driverId ?? null}
              options={availableDriverOptions}
              onChange={handleDriverSelection}
            />
            {data?.driverNumber && (
              <div>
                <span
                  className={`${classes.labelValue} ${classes.labelWithDropdown}`}
                >
                  {`#${data.driverNumber}`}
                </span>
              </div>
            )}
            {data?.driverError && (
              <span
                className={`${classes.driverStatusError} ${classes.errorPadding}`}
              >
                {data.driverError}
              </span>
            )}
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(PanelHeader);
